<template>
    <div>
        <el-button size="mini" icon="el-icon-plus" @click="toEdit(null)">新增</el-button>
        <el-table :data="list_data.list" v-loading="loading" style="width: 100%">
            <el-table-column prop="id" label="ID" width="123"></el-table-column>
            <el-table-column prop="name" label="店铺名称" width="123"></el-table-column>
            <el-table-column prop="platform_app_id" label="应用ID" width="180">
                <template slot-scope="scope">
                  <p>店铺：{{scope.row.platform_app_id}}</p>
                  <p>网卡：{{scope.row.eth_bind_ip}}</p>
                </template>               
            </el-table-column>
            <el-table-column prop="order_prefix" label="订单前缀" width="123"></el-table-column>
            <el-table-column prop="platform_label" label="应用类型" width="111"></el-table-column>
            <el-table-column prop="mobile" label="手机号" width="155"></el-table-column>
            <el-table-column prop="service_email" label="邮箱" width="255"></el-table-column>
            <el-table-column prop="statusShow.label" label="启用状态" width="100">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status_bool" active-color="#13ce66" inactive-color="#aaaaaa" @change="changeStatus(scope.row)"></el-switch>
                </template>                
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="ctime" label="操作" min-width="100" align="right">
                <template slot-scope="scope">
                    <el-tag size="mini" class="pointer" @click="to_auth(scope.row)">授权</el-tag>
                    <el-tag size="mini" class="pointer" @click="to_sync(scope.row)">同步</el-tag>
                    <el-tag size="mini" type="info" class="pointer" @click="toEdit(scope.row)">编辑</el-tag>
                    <el-tag size="mini" type="info" class="pointer" @click="remove(scope.row.id)">删除</el-tag>
                </template>        
            </el-table-column>
        </el-table>    
        <component :is="popName" :item="editItem"></component>
    </div>
</template>
<script>
const edit = resolve => require(['@/pages/setting/applets/_edit'], resolve);  
export default {
  components:{
      edit,
  },
  data(){
      return {
          loading:false,
          popName:null,
          editItem:null,
          filter:{

          },
          list_data:{
              total:0,
              size:10,
              list:[],
          },
      }
  },
  methods:{
    toEdit(row = null){
        if (row) {
            this.editItem = row
        }
        this.popName = 'edit'
    },
    to_auth(row) { 
      var token = localStorage.getItem("token");
      window.open('/seller-api/v1/pub/shopify-app/index-from-erp?token=' + token +'&app_id=' + row.id, true)
    },
    to_sync(row){
        this.loading = true;
        this.$http.post('/v1/pri/cfg-applets/sync-shop-info', {id:row.id})
        .then( (response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getList()
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })            
    },
    changeStatus(item){
        this.$http.post('/v1/pri/cfg-applets/set-status', {id:item.id, status:item.status_bool ? 1 : 0})
        .then( (response) => {
            var res = response.data;
            if (res.code == 1) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: res.msg,
                    type: 'warning'
                });
            }
        })             
    },
    getList(){
        this.loading = true;
        this.$http.post('/v1/pri/cfg-applets/lists', this.filter)
        .then( (response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
                this.list_data = res.data
            }
        })            
    },
    remove(id){
        this.$confirm('删除属性', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$store.commit('setLoading', {text:'正在移除..'});
            this.$http.post('/v1/pri/cfg-applets/remove', {ids:[id]})
                .then( (response) => {
                    this.$store.commit('setLoading', {text:false});
                    var res = response.data;
                    if (res.code == 1) {
                        this.$message({
                            message: '移除成功',
                            type: 'success'
                        });
                        this.getList()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                })
                .catch( (error) => {
                    this.$store.commit('setLoading', {text:false});
                }) 
        }) 
    },
  },
  mounted(){
      this.getList()
  },
}
</script>


// WEBPACK FOOTER //
// src/pages/setting/applets/_list.vue